import { m as moment, D as DATE_FORMATS } from '../../../momentFormat-14fce7b4.js';
import { N as applicationStore } from '../../../loadingStore-ee04ce42.js';
import '../store/chatStore.js';
import '../store/wageringStore.js';
import '../store/roundInfoStore.js';
import '../store/userCountStore.js';
import '../store/gameResultStore.js';
import '../store/resultHashStore.js';
import '../store/userWinBetsStore.js';
import '../store/notificationStore.js';
import '../store/selectedResultInfoStore.js';
import '../../../_commonjsHelpers-1a7a244d.js';
import '../../../tslib.es6-14c74580.js';
import 'mobx';
import '@microsoft/signalr';
import '../services/liveConnection/types.js';
import '../classes/httpResponse/index.js';
import '../enums/GameSpecificTypes.js';
import '../enums/MaxPayoutDataTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/TimeoutMaxValue.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import '../enums/DefaultQueryValues.js';
import '../enums/FreeBetWinningType.js';
import '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/RequestStatus.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';
import './environmentBuilder.js';
import '../enums/BogLineGameConfig.js';
import './parseQuery.js';
import 'axios';
import '../services/sound/types.js';
import '../services/sound/SoundService.js';
import 'howler';
import '../services/sound/defaultSounds.js';
import '../services/api/types.js';
import '../services/api/BaseApiService.js';
import '../enums/StatisticsSortingTypes.js';
import '../services/ApiServices.js';
import '../polyfill.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import './formatDate.js';
import './isMobile.js';
import './updateHalfBets.js';
import '../enums/bogGameNames.js';

var translateMonth = function (date, format) {
    if (format === void 0) { format = DATE_FORMATS.CHART_II; }
    var translator = applicationStore.translator;
    var month = moment(date).format('MMMM');
    var translatedMonth = translator(month.toUpperCase());
    var restOfDate = moment(date).format(format.replace('MMMM', ''));
    var splitResult = restOfDate.split(' ').slice(1).join(' ');
    return "".concat(translatedMonth, " ").concat(splitResult);
};

export { translateMonth };
